import httpClient from '../axios';

const URL = 'menu';

const menu = async (data) => httpClient.post(URL, data);

export default menu;
